import { render, staticRenderFns } from "./VLogoRobbu.vue?vue&type=template&id=95fa6870&scoped=true"
import script from "./VLogoRobbu.vue?vue&type=script&lang=js"
export * from "./VLogoRobbu.vue?vue&type=script&lang=js"
import style0 from "./VLogoRobbu.vue?vue&type=style&index=0&id=95fa6870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fa6870",
  null
  
)

export default component.exports